import classNames from "classnames";
import OnahButton from "components/OnahButton";
import { ReactComponent as Info } from "assets/svgs/info.svg";
import { FC, useEffect, useState } from "react";
import { useOnahSelector } from "store/hooks";
import OnahSwitch from "components/OnahSwitch";
import { KybStatus } from "interface/merchant";
import { updateDomain } from "services/merchant";
import { Domain } from "interface/User";
import { useNavigate } from "react-router-dom";
import { Routes } from "routes/routes";
import { CheckSquareOutlined } from "@ant-design/icons";

type Props = {
  className?: string;
  btnClassname?: string;
  businessClassName?: string;
  spanClassName?: string;
};

const MerchantLogo: FC<Props> = ({
  className,
  btnClassname,
  businessClassName,
  spanClassName,
}) => {
  const { merchant } = useOnahSelector((state) => state.user);
  const [checked, setChecked] = useState(merchant?.user.domain === Domain.LIVE);
  const navigate = useNavigate();

  useEffect(() => {
    setChecked(merchant?.user.domain === Domain.LIVE);
  }, [merchant]);

  const changeDomain = async () => {
    setChecked(!checked);
    const response = await updateDomain(
      merchant?.user.domain === Domain.LIVE ? Domain.TEST : Domain.LIVE,
    );
    if (response) {
      window.location.reload();
    } else {
      setChecked(merchant?.user.domain === Domain.LIVE);
    }
  };

  return (
    <div
      className={classNames(
        "flex items-center 2xl:gap-x-[40px] gap-x-[20px]",
        className,
      )}
    >
      <div
        className={classNames("flex items-center space-x-1 max-w-[340px]")}
        onClick={() => navigate(Routes.dashboard)}
        role="button"
      >
        <h1
          className={classNames(
            "font-acorn font-bold max-2xl:text-[28px] lg:text-[32px] text-lg text-header-title text-ellipsis whitespace-nowrap truncate",
            businessClassName,
          )}
        >
          {merchant?.name}
        </h1>
        {/* <TinyCaretDown /> */}
      </div>

      {merchant?.kybStatus === KybStatus.UNVERIFIED && (
        <OnahButton
          type="button"
          className={classNames(
            "!2xl:text-[16px] !text-[14px] !bg-orange-secondary/5 flex items-center 2xl:space-x-[8px] space-x-[4px]",
            "!text-orange-secondary border border-orange-secondary/40",
            btnClassname,
          )}
        >
          <Info className="2xl:w-[12px] 2xl:h-[12px] w-[10px] :h-[10px] text-orange-secondary/50" />
          <span className={classNames(spanClassName)}>Test Mode</span>
        </OnahButton>
      )}
    </div>
  );
};

export default MerchantLogo;
